import "./styles.css";
import { initSentry } from "./sentry";
import App from "./App";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";

// Initialize Sentry first
initSentry();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
